import { render } from "./AirplaneClockIcon.vue?vue&type=template&id=60c394c0"
import script from "./AirplaneClockIcon.vue?vue&type=script&lang=js"
export * from "./AirplaneClockIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__